(function () {
  var ROOT_SELECTOR = '[data-magazine-issue-reader]';
  var MOBILE_QUERY = '(max-width: 749px)';
  var VALID_LAYOUTS = ['singlePage', 'doublePage'];

  function normalizeLayout(value, fallback) {
    return VALID_LAYOUTS.indexOf(value) !== -1 ? value : fallback;
  }

  function buildEmbedUrl(source, layout) {
    try {
      var url = new URL(source, document.baseURI);
      url.searchParams.set('pageLayout', layout);
      return url.toString();
    } catch (error) {
      var separator = source.indexOf('?') === -1 ? '?' : '&';
      return source + separator + 'pageLayout=' + encodeURIComponent(layout);
    }
  }

  function initializeReader(root) {
    if (!root || root.dataset.magazineIssueReaderInitialized === 'true') return;

    var frame = root.querySelector('[data-magazine-issue-frame]');
    var controls = root.querySelector('[data-magazine-view-controls]');
    var buttons = root.querySelectorAll('[data-magazine-view-layout]');
    if (!frame || !controls || !buttons.length) return;

    var source = frame.getAttribute('data-src');
    if (!source) return;

    var desktopDefault = normalizeLayout(root.dataset.defaultLayoutDesktop, 'doublePage');
    var mobileDefault = normalizeLayout(root.dataset.defaultLayoutMobile, 'singlePage');
    var initialLayout = window.matchMedia(MOBILE_QUERY).matches ? mobileDefault : desktopDefault;
    var currentLayout = '';

    function setLayout(layout) {
      var nextLayout = normalizeLayout(layout, initialLayout);

      buttons.forEach(function (button) {
        var isActive = button.dataset.magazineViewLayout === nextLayout;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      if (currentLayout !== nextLayout) {
        frame.src = buildEmbedUrl(source, nextLayout);
        frame.hidden = false;
        currentLayout = nextLayout;
      }
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        setLayout(button.dataset.magazineViewLayout);
      });
    });

    controls.hidden = false;
    root.dataset.magazineIssueReaderInitialized = 'true';
    setLayout(initialLayout);
  }

  function initializeAll(scope) {
    if (scope.matches && scope.matches(ROOT_SELECTOR)) initializeReader(scope);
    scope.querySelectorAll(ROOT_SELECTOR).forEach(initializeReader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeAll(document);
    });
  } else {
    initializeAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });
})();
